import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { Api } from "../axios-config"
import { AES, enc } from "crypto-js";
const secret = "MudFaz";

export const AnosTemporadas = [
    {
        codigo: 1,
        label: "1 ano"
    },
    {
        codigo: 2,
        label: "2 anos"
    },
    {
        codigo: 3,
        label: "3 anos"
    },
    {
        codigo: 4,
        label: "4 anos"
    },
    {
        codigo: 5,
        label: "5 anos"
    }
];

export const lstReferenciasPosicaoConfronto = [{
    codigo: 1,
    label: "PG",
    visivel: true
},
{
    codigo: 2,
    label: "SG",
    visivel: true
},
{
    codigo: 3,
    label: "SF",
    visivel: true
},
{
    codigo: 4,
    label: "PF",
    visivel: true
},
{
    codigo: 5,
    label: "C",
    visivel: true
},
{
    codigo: 6,
    label: "6º",
    visivel: false

},
{
    codigo: 7,
    label: "RC",
    visivel: false

},
{
    codigo: 8,
    label: "RG",
    visivel: false

},
{
    codigo: 9,
    label: "RF",
    visivel: false

},
{
    codigo: 10,
    label: "7º",
    visivel: false

},];

export const lstReferenciasPosicao = [{
    codigo: 1,
    label: "PG",
    visivel: true
},
{
    codigo: 2,
    label: "SG",
    visivel: true
},
{
    codigo: 3,
    label: "SF",
    visivel: true
},
{
    codigo: 4,
    label: "PF",
    visivel: true
},
{
    codigo: 5,
    label: "C",
    visivel: true
}
];

export const lstPosicaoAmericana = [{
    codigo: 1,
    label: "PG",
    visivel: true
},
{
    codigo: 2,
    label: "SG",
    visivel: true
},
{
    codigo: 3,
    label: "SF",
    visivel: true
},
{
    codigo: 4,
    label: "PF",
    visivel: true
},
{
    codigo: 5,
    label: "5º",
    visivel: true
},
{
    codigo: 6,
    label: "6º",
    visivel: true

}];

export const lstReferenciasPosicaoAmericano = [{
    codigo: 1,
    label: "G",
    visivel: true
},
{
    codigo: 2,
    label: "G",
    visivel: true
},
{
    codigo: 3,
    label: "F",
    visivel: true
},
{
    codigo: 4,
    label: "F",
    visivel: true
},
{
    codigo: 5,
    label: "C",
    visivel: true
},
{
    codigo: 6,
    label: "6º",
    visivel: true

}
];

export const lstPosicaoAmericano = [{
    codigo: 1,
    label: "G",
    visivel: true
},
{
    codigo: 2,
    label: "F",
    visivel: true
},
{
    codigo: 3,
    label: "C",
    visivel: true
}
];

export const tipoConfronto = [{
    codigo: 1,
    label: "Todos"
},
{
    codigo: 2,
    label: "Temporada Regular"
},
{
    codigo: 3,
    label: "Play IN/OFF"
},
]

export type TDropOptions = {
    codigo: number;
    label: string;
    descricao: string;
}

export const TipoSalario =
    [{
        codigo: 1,
        label: "Normal",
        color: "auto"
    },
    {
        codigo: 2,
        label: "Player Option",
        color: "#28a1db"

    },
    {
        codigo: 3,
        label: "Team Option",
        color: "#d56413"
    },
    {
        codigo: 4,
        label: "Qualifying Offer",
        color: "#36ae2c"
    },
    {
        codigo: 5,
        label: "Two-way Contract",
        color: "#e51a8a"
    }];



export const lstDropDireitos = [{
    codigo: 1,
    label: "TODOS"
},
{
    codigo: 2,
    label: "Com direito"
},
{
    codigo: 3,
    label: "Sem direito"
}];

export const lstTiposAtivos = [

    {
        codigo: 1,
        label: "Jogadores"
    },
    {
        codigo: 2,
        label: "Direitos"
    },
    {
        codigo: 3,
        label: "Multas"
    },
    {
        codigo: 4,
        label: "Picks"
    },
    {
        codigo: 5,
        label: "Pick Protegida"
    },
    {
        codigo: 6,
        label: "Swap"
    }
];

export const dropOpcoesFaleConosco = [{
    codigo: 1,
    label: "Elogio"
},
{
    codigo: 2,
    label: "Sugestão"
},
{
    codigo: 3,
    label: "Erro"
},
{
    codigo: 4,
    label: "Inconsistência"
},
{
    codigo: 5,
    label: "Telegram"
},
{
    codigo: 100,
    label: "Outros"
}]

export const lstDropLance = [{
    codigo: 1,
    label: "TODOS"
},
{
    codigo: 2,
    label: "Com lance"
},
{
    codigo: 3,
    label: "Sem lance"
}]

export const EnumSituacaoProposta = [{
    codigo: 1,
    label: "AR",
    descricao: "Aguardando Resposta"
},
{
    codigo: 2,
    label: "A",
    descricao: "Aceita"
},
{
    codigo: 3,
    label: "R",
    descricao: "Rejeitada"
}];

export const enumFormasPagamento = [
    {
        codigo: 1,
        label: "Boleto",
        visible: true
    },
    {
        codigo: 2,
        label: "Cartão Crédito",
        visible: true
    },
    {
        codigo: 3,
        label: "Cartão de Débito",
        visible: true

    },
    {
        codigo: 4,
        label: "Pix",
        visible: true
    },
    {
        codigo: 5,
        label: "Dinheiro",
        visible: false
    }
];

export const statusFinanceiro = [
    {
        codigo: 1,
        label: "Pendente",
        descricao: "Pendente Pagamento"
    },
    {
        codigo: 2,
        label: "SolicitadoPagamento",
        descricao: "Solicitado Pagamento"
    },
    {
        codigo: 3,
        label: "AguardandoPagamento",
        descricao: "Aguardando Pagamento"
    },
    {
        codigo: 4,
        label: "Baixa",
        descricao: "Realizando Baixa"
    },
    {
        codigo: 5,
        label: "Pago",
        descricao: "Pagamento Realizado"
    }
    ,
    {
        codigo: 6,
        label: "Gratuito",
        descricao: "Gratuito"
    }
];

export const tipoConfrontoPlayOff =
    [
        {
            codigo: 1,
            label: "Play in - Rodada 1"
        },
        {
            codigo: 2,
            label: "Play in - Rodada 2",
        },
        {
            codigo: 3,
            label: "Play off - Rodada 1",
        },
        {
            codigo: 4,
            label: "Play off - Rodada 2",
        },
        {
            codigo: 5,
            label: "Final Conferência",
        },
        {
            codigo: 6,
            label: "Final Liga",
        },

    ]

export const tipoConfrontoPlayOffCopinha =
    [
        {
            codigo: 1,
            label: "Oitavas"
        },
        {
            codigo: 2,
            label: "Quartas",
        },
        {
            codigo: 3,
            label: "Semi",
        },
        {
            codigo: 4,
            label: "Final",
        }
    ]

export const tipoDisponibilizacaoJogador =
    [
        {
            codigo: 1,
            label: "Nada Específico"
        },
        {
            codigo: 2,
            label: "Jogadores Jovens",
        },
        {
            codigo: 3,
            label: "Jogador Mesmo Nível",
        },
        {
            codigo: 4,
            label: "Picks Próximas",
        },
        {
            codigo: 5,
            label: "Picks Futuras",
        },
        {
            codigo: 6,
            label: "Pacote de Ativos",
        },
    ];


export const tiposLiga = [{
    codigo: 1,
    label: "Normal"
},
{
    codigo: 2,
    label: "Estrela"
},
{
    codigo: 3,
    label: "Atemporal"
}];

export const lstDropTipoContratoAjustado = [{
    codigo: 1,
    label: "Linear"
},
{
    codigo: 2,
    label: "Progressiva"
},
{
    codigo: 3,
    label: "Regressiva"
}]

export const terminoLeilao =
    [
        {
            codigo: 1,
            label: "Diário"
        },
        {
            codigo: 2,
            label: "Sexta-Feira",
        },
        {
            codigo: 3,
            label: "Sábado",
        },
        {
            codigo: 4,
            label: "Domingo",
        },
        {
            codigo: 5,
            label: "Segunda-Feira",
        }
    ];

export const quantidadeDeJogos =
    [
        {
            codigo: 5,
            label: "5"
        },
        {
            codigo: 10,
            label: "10",
        },
        {
            codigo: 15,
            label: "15",
        },
        {
            codigo: 20,
            label: "20",
        },
        {
            codigo: 25,
            label: "25",
        },
        {
            codigo: 30,
            label: "30",
        },
        {
            codigo: 35,
            label: "35",
        },
        {
            codigo: 40,
            label: "40",
        },

    ]

export const porcentagemStats =
    [
        {
            codigo: 1,
            label: "x3"
        },
        {
            codigo: 2,
            label: "x2.5",
        },
        {
            codigo: 3,
            label: "x2",
        },
        {
            codigo: 4,
            label: "x1.5",
        },
        {
            codigo: 5,
            label: "x1.25",
        },
        {
            codigo: 6,
            label: "x1",
        },
        {
            codigo: 7,
            label: "x0.75",
        },
        {
            codigo: 8,
            label: "x0.5",
        },
        {
            codigo: 9,
            label: "x0.25",
        },

    ]

export const enumLstStats = [{
    codigo: 1,
    label: "fgm"
},
{
    codigo: 2,
    label: "fga"
},
{
    codigo: 3,
    label: "ftm"
},
{
    codigo: 4,
    label: "fta"
}
    ,
{
    codigo: 5,
    label: "threepm"
}
    ,
{
    codigo: 6,
    label: "threepa"
},
{
    codigo: 7,
    label: "pts"
},
{
    codigo: 8,
    label: "reb"
},
{
    codigo: 9,
    label: "oreb"
},
{
    codigo: 10,
    label: "dreb"
},
{
    codigo: 11,
    label: "ast"
},
{
    codigo: 12,
    label: "stl"
},
{
    codigo: 13,
    label: "blk"
},
{
    codigo: 14,
    label: "to"
},
{
    codigo: 15,
    label: "pf"
},
{
    codigo: 16,
    label: "mplus"
}
    ,
{
    codigo: 17,
    label: "fgmp"
}
    ,
{
    codigo: 18,
    label: "ftmp"
}
    ,
{
    codigo: 19,
    label: "threepmp"
}
    ,
{
    codigo: 20,
    label: "fge"
}
    ,
{
    codigo: 21,
    label: "fte"
}
    ,
{
    codigo: 22,
    label: "threepe"
}
    ,
{
    codigo: 23,
    label: "stocks"
}
];

export const enumLstCriterioDesempate = [
    {
        codigo: 1,
        label: "Maior Número de Vitórias"
    },
    {
        codigo: 2,
        label: "Confronto direto"
    },
    {
        codigo: 3,
        label: "Mais vitórias na sua divisão"
    },
    {
        codigo: 4,
        label: "Mais vitórias na sua conferência"
    }
    ,
    {
        codigo: 5,
        label: "Sequência de vitórias finais"
    }
    ,
    {
        codigo: 6,
        label: "Diferença de saldo nas vitórias"
    },
]

export const enumMargemAposta =
    [
        {
            codigo: 1,
            label: "5"
        },
        {
            codigo: 2,
            label: "10",
        },
        {
            codigo: 3,
            label: "15",
        },
        {
            codigo: 4,
            label: "20",
        },
        {
            codigo: 5,
            label: "25+",
        }
    ]

    export const enumSituacaoAposta =
    [
        {
            codigo: 1,
            label: "Realizada"
        },
        {
            codigo: 2,
            label: "Vencida",
        },
        {
            codigo: 3,
            label: "Perdida",
        },        
    ]



interface IDetalheCEP {
    cep: string;
    logradouro: string;
    bairro: boolean;
    ufSigla: string;
    localidade: string;

}

export interface ILstDrop {
    codigo: number;
    label: string;
}

interface IDetalheDadosPessoaCNPJ {
    cnpj: string;
    nome: string;
    fantasia: boolean;
    abertura: string;
    situacao: string;
    telefone: string;
    cep: string;
    logradouro: string;
    bairro: boolean;
    uf: string;
    municipio: string;

}

export interface IDadosTemporadas {
    codigo: number;
    descricao_Temporada: string;
    situacao: boolean;

}

export interface IDadosRetornoTemporadas {
    dado: IDadosTemporadas[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}

type TTemporadaComTotalCount = {
    data: IDadosRetornoTemporadas;
    totalCount: number;
}

export interface IDadosStats {
    codigo: number;
    stats: string;
    peso: string;
    situacao: boolean;
    nome: string;
    peso_Padrao: string;
    descricao?: string;
}

export interface IDadosStatsHeader {
    codigo: number;
    codigo_Liga: number;
    codigo_Temporada: number;
    nome: string;
    descricao?: string;
}

export interface IDadosRetornoStats {
    dado: IDadosStats[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosRetornoStatsHeader {
    dado: IDadosStatsHeader[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosJogosRodadaNba {
    codigo_Jogo_NBA: number,
    codigo_Franquia_Atual: number,
    nome_Franquia: string,
    mandante: boolean;
    pontos: number;

}

type TStatsComTotalCount = {
    data: IDadosRetornoStats;
    totalCount: number;
}

type TStatsComTotalCountHeader = {
    data: IDadosRetornoStats;
    totalCount: number;
}

export interface IFile {
    files: File[]
}

export interface IDetalheFaleConosco {
    codigo: number;
    codUsuCriacao: number;
    arquivos: File;
    arquivo_Anexo: string;
    mensagem: string;
    tipo: number;
}

export interface IDadosRetornoArquivo {
    data: {
        dado: IDadosRespArquivo[];
        erros: string;
        mensagem: string;
        processado: boolean;
        status: number;
        statusHTTP: number;
    }
}

export interface IDadosRespArquivo {
    caminho: string;
    nome: string;
    nomeReal: string;
}

export interface IDadosRetornoDescricaoTemporada {
    dado: IDadosDescricaoTemporada;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosDescricaoTemporada {
    ano1: string;
    descricao_Ano1: string;
    ano2: string;
    descricao_Ano2: string;
    ano3: string;
    descricao_Ano3: string;
    ano4: string;
    descricao_Ano4: string;
    ano5: string;
    descricao_Ano5: string;
    ano6: string;
    descricao_Ano6: string;

}

export interface IDadosRetornoBlogs {
    dado: IDadosBlog[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosBlog {
    codigo: number;
    url: string;
    atual: boolean;
    tipo: number;
}

export interface IDadosRetornoBlog {
    dado: IDadosBlog;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosRetornoTemporadaAtual {
    dado: IDadosTemporadas;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;

}

export interface IDadosRetornoPodcasts {
    dado: IDadosPodcasts[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosPodcasts {
    codigo: number;
    rating?: number;
    url: string;
    atual: boolean;
    data: Date;
}

export interface IDadosRetornoQtdRodadas {
    dado: number[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosRetornoFutebol {
    dado: IDadosTimes[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosTimes {
    codigo: number;
    nome: string;
    escudo?: string;

}

export interface IDadosRetornoItensOptions {
    dado: IDadosItensOptions[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

export interface IDadosItensOptions {
    codigo: number;
    descricao: string;
    codUsuCriacao: number;
    dtrCriacao: Date;
    repetir: boolean;
}

export const maskCNPJEvent = (event: React.FormEvent<HTMLInputElement>) => {
    event.currentTarget.maxLength = 18;
    const { value } = event.currentTarget;
    if (event.currentTarget.value.length <= 18) {
        return value.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "")
            .replace(/^(\d{2})(\d)/, "$1.$2")     // Coloca ponto entre o 2º e 3º dígitos
            .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3") // Coloca ponto entre o 5º e 6º dígitos
            .replace(/\.(\d{3})(\d)/, ".$1/$2")   // Coloca uma barra entre o 8º e 9º dígitos
            .replace(/(\d{4})(\d)/, "$1-$2");    // Coloca um hífen depois do bloco de 4 dígitos


    }
    // Aplica a máscara: 00.000.000/0000-00
    return value
        .replace(/^(\d{2})(\d)/, "$1.$2")     // Coloca ponto entre o 2º e 3º dígitos
        .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3") // Coloca ponto entre o 5º e 6º dígitos
        .replace(/\.(\d{3})(\d)/, ".$1/$2")   // Coloca uma barra entre o 8º e 9º dígitos
        .replace(/(\d{4})(\d)/, "$1-$2");    // Coloca um hífen depois do bloco de 4 dígitos



};

export const maskCPFEvent = (event: React.FormEvent<HTMLInputElement>) => {
    event.currentTarget.maxLength = 15;
    const { value } = event.currentTarget;

    return value
        .replace(/\D/g, '')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
};

const getEnderecoByCep = async (cep: string): Promise<IDetalheCEP> => {
    const token = localStorage.getItem("@Auth:token");
    const { data } = await Api.get<IDetalheCEP>(`https://viacep.com.br/ws/${cep}/json/`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getDadosPessoaJuridicaByCNPJ = async (cep: string): Promise<IDetalheDadosPessoaCNPJ> => {
    const token = localStorage.getItem("@Auth:token");
    const { data } = await Api.get<IDetalheDadosPessoaCNPJ>(`/Parceiro/Cnpj/`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getTemporadas = async (situacao = false, codigoLiga: number, codigo = 0): Promise<TTemporadaComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/dadosgerais/temporada`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: codigo > 0 ? codigo : null,
            Descricao_Temporada: null,
            Situacao: situacao,
            Codigo_Liga: codigoLiga
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getTemporadaAtual = async (): Promise<IDadosRetornoTemporadaAtual> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/dadosgerais/temporada/atual`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const getTemporadasLiga = async (codigoLiga: number): Promise<TTemporadaComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/dadosgerais/temporada/liga/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getTemporadasLigaPorTipoQtd = async (codigoLiga: number, ordenacao: number = 1, quantidadeAnterior: number = 4, quantidadePosterior: number = 0): Promise<TTemporadaComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/dadosgerais/temporada/filtros`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo_Liga: codigoLiga > 0 ? codigoLiga : null,
            Ordenacao: ordenacao,
            Quantidade_Anterior: quantidadeAnterior,
            Quantidade_Posterior: quantidadePosterior
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getStats = async (situacao = true, codigo = 0): Promise<TStatsComTotalCount> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/dadosgerais/stats`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: codigo > 0 ? codigo : null,
            stats: null,
            Situacao: situacao
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getStatsLigaPorCodigoLiga = async (codigoLiga = 0): Promise<TStatsComTotalCountHeader> => {

    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/disputa/stats/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getItensPlayerOption = async (): Promise<IDadosRetornoItensOptions> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`dadosgerais/playeroption/itens`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const createFaleConosco = async (dados: Omit<IDetalheFaleConosco, "codigo">): Promise<number> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.post<IDetalheFaleConosco>(`/faleconosco`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    }
    );

    return data.codigo
}

const upLoadArquivo = async (file: any): Promise<IDadosRetornoArquivo> => {
    const formData = new FormData();
    formData.append('img', file);

    const token = CookieService.get("access_token");
    return await Api.post('/fileUpload/upload', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
            'Access-Control-Allow-Origin': '*',
            'chavesessao': token,
            'tipo': "faleConosco"
        }
    }).then(res => res)
        .catch((error) => error.response);
}

const getDescricaoTemporadoPorCodigoLiga = async (codigoLiga = 1): Promise<IDadosRetornoDescricaoTemporada> => {

    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/dadosgerais/temporada/descricao/${codigoLiga}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data
}

const getDescricaoTemporadoPorCodigoTemporada = async (codigoTemporada = 0): Promise<IDadosRetornoDescricaoTemporada> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/dadosgerais/temporada/descricao/codigo/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data
}

const getListaUrlBlogs = async (codigoParceiro: number): Promise<IDadosRetornoBlogs> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/configuracaoBlog/lista/atual/${codigoParceiro}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data
}

export interface IFiltosBlog {
    codigo?: number;
    codigo_Parceiro?: number;
    url?: string;
    tipo?: number;

}

const getPodCasts = async (dadosFiltro: IFiltosBlog): Promise<IDadosRetornoPodcasts> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/configuracaoBlog`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        },
        params: {
            Codigo: Number(dadosFiltro.codigo) > 0 ? dadosFiltro.codigo : null,
            Codigo_Parceiro: Number(dadosFiltro.codigo_Parceiro) > 0 ? dadosFiltro.codigo_Parceiro : null,
            Url: dadosFiltro.url !== undefined ? dadosFiltro.url : null,
            Tipo: Number(dadosFiltro.tipo) > 0 ? dadosFiltro.tipo : null
        }
    });
    return data
}

const getUrlBlogAtual = async (codigoParceiro: number): Promise<IDadosRetornoBlog> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/configuracaoBlog/atual/${codigoParceiro}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data
}

const crypt = (valor: string) => {
    const cipherText = AES.encrypt(valor, secret)

    var e64 = enc.Base64.parse(cipherText.toString());
    var eHex = e64.toString(enc.Hex);
    return eHex;
    // return cipherText.toString();
};

const decrypt = (cipherText: string) => {

    try {
        var reb64 = enc.Hex.parse(cipherText);
        var bytes = reb64.toString(enc.Base64);
        var decrypt = AES.decrypt(bytes, secret);
        var plain = decrypt.toString(enc.Utf8);
        return plain;
    } catch (err) {
        console.log('UNABLE TO DECIPHER', err);
    }

};

const checkUrlImagem = async (url: string) => {
    if (url === undefined) {
        return false;
    }
    var img = document.createElement('img');
    img.src = url;
    img.onload = () => {
        return true;
    }
    img.onerror = () => {

        return false;
    }
}

const verificaTipoPosicao = (posicao: string) => {

    let imagemPosicao = "";
    switch (posicao) {
        case 'PG':
            imagemPosicao = "../../pg.png"
            break;
        case 'SG':
            imagemPosicao = "../../sg.png"
            break;
        case 'PF':
            imagemPosicao = "../../pf.png"
            break;
        case 'SF':
            imagemPosicao = "../../sf.png"
            break;
        case 'C ':
            imagemPosicao = "../../c.png"
            break;
        case 'G ':
            imagemPosicao = "../../g.png"
            break;
        case 'F ':
            imagemPosicao = "../../f.png"
            break;
        case 'C':
            imagemPosicao = "../../c.png"
            break;
        case 'G':
            imagemPosicao = "../../g.png"
            break;
        case 'F':
            imagemPosicao = "../../f.png"
            break;
        default:
            imagemPosicao = "../../semposicao.png"

    }

    return imagemPosicao;
}

const verificaCorPosicao = (posicao: string) => {
    let corPosicao = "";
    switch (posicao.trim()) {
        case 'PG':
            corPosicao = "#0D29D5"
            break;
        case 'SG':
            corPosicao = "#0D1346"
            break;
        case ("PF"):
            corPosicao = "#12460D"
            break;
        case ('F'):
            corPosicao = "#12460D"
            break;
        case ('F '):
            corPosicao = "#12460D"
            break;
        case 'SF':
            corPosicao = "#4EA058"
            break;
        case ('C'):
            corPosicao = "#73045b"
            break;
        case ('C '):
            corPosicao = "#73045b"
            break;
        case ('RC'):
            corPosicao = "#73045b"
            break;
        case ('G'):
            corPosicao = "#0D29D5"
            break;
        case ('G '):
            corPosicao = "#0D29D5"
            break;
        default:
            corPosicao = "darkGray"

    }

    return corPosicao;
}

const isMobile = () => {
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.search(/(android|avantgo|blackberry|bolt|boost|cricket|docomo|fone|hiptop|mini|mobi|palm|phone|pie|tablet|up\.browser|up\.link|webos|wos)/i) !== -1)
        return true;
}

const getQtdeRodadasPorLigaTemporada = async (codigoLiga: number, codigoTemporada: number): Promise<IDadosRetornoQtdRodadas> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/dadosgerais/liga/rodada/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const getListaTimesFutebol = async (): Promise<IDadosRetornoFutebol> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get<IDadosRetornoFutebol>(`/dadosgerais/futebol/time`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

export const UtilidadeService = {
    getEnderecoByCep,
    getTemporadas,
    getStats,
    getStatsLigaPorCodigoLiga,
    crypt,
    decrypt,
    checkUrlImagem,
    verificaTipoPosicao,
    createFaleConosco,
    upLoadArquivo,
    verificaCorPosicao,
    getDescricaoTemporadoPorCodigoLiga,
    getListaUrlBlogs,
    getUrlBlogAtual,
    getPodCasts,
    isMobile,
    getTemporadasLiga,
    getDescricaoTemporadoPorCodigoTemporada,
    getTemporadasLigaPorTipoQtd,
    getQtdeRodadasPorLigaTemporada,
    getListaTimesFutebol,
    getItensPlayerOption,
    getDadosPessoaJuridicaByCNPJ,
    getTemporadaAtual
}